module.exports = __webpack_public_path__ + "img/keyPadPlus.7b7792bc.webp";